import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { Badge, Table } from 'antd';

function toPercentage(value) {
  return Math.round(value * 10000) / 100;
}

@inject('reportStore', 'deviceGroupStore')
@observer
class ReportTable extends Component {
  render() {
    const { reportDateTotal } = this.props.reportStore;
    const { onChangePage, page_num, data } = this.props;
    const realData = Array.from(data);
    const columns = [
      {
        title: '设备编号',
        dataIndex: 'deviceId',
        width: 200,
        render: text => (
          <Link style={{ color: '#49aff7' }} to={`/device/info/${text}`}>
            {text}
          </Link>
        )
      },
      {
        title: '状态',
        dataIndex: 'onlineStatus',
        width: 100,
        render: value =>
          value === 1 ? (
            <Badge status="success" text="在线" />
          ) : value === 0 ? (
            <Badge status="error" text="离线" />
          ) : (
            <Badge color="#ccc" text="未知" />
          )
      },
      {
        title: '在线状态变更时间',
        dataIndex: 'onlineChangeTime',
        width: 200
      },
      {
        title: 'IMEI',
        dataIndex: 'imei',
        width: 200
      },
      {
        title: 'ICCID',
        dataIndex: 'iccid',
        width: 200
      },
      {
        title: '移动流量(月/M)',
        dataIndex: 'dataUsage',
        width: 150
      },
      {
        title: '内存使用率(%)',
        dataIndex: 'memoryUsage',
        width: 150,
        render: toPercentage
      },
      {
        title: '存储使用率(%)',
        dataIndex: 'storageUsage',
        width: 150,
        render: toPercentage
      },
      {
        title: 'CPU使用率(%)',
        dataIndex: 'cpuUsage',
        width: 150,
        render: toPercentage
      },
      {
        title: '客户名称',
        dataIndex: 'clientName',
        width: 300
      },
      {
        title: '地址',
        dataIndex: 'address',
        width: 400
      },
      {
        title: '最后上报时间',
        dataIndex: 'lastUpdateTime',
        width: 200
      }
    ];
    return (
      <Table
        pagination={{
          pageSize: 20,
          total: reportDateTotal,
          onChange: onChangePage,
          current: page_num
        }}
        columns={columns}
        dataSource={realData}
        scroll={{ x: 1300 }}
        rowKey={(r, i) => i}
      />
    );
  }
}

export default ReportTable;



// WEBPACK FOOTER //
// ./src/components/Report/ReportTable.js